const coachDataList = [
  {
    name: '夏依',
    topImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a86de68426258eeb032e75e93b8a3813.png', //顶部图片
    bottomImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/886a7c3ee9c1b8206cd4490cbd65c0cc.png', //顶部图片
    id: 70,
    extendId: 36,
    coachImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d58ddafcdb1c916e882e9df942d34624.png',
    fixedUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fff1c565559c8052ba21fc9aaacc8b2f1.png'
  },
  {
    name: '余晏',
    topImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1d43036d632c9f581989d2100555dd01.png', //顶部图片
    bottomImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/886a7c3ee9c1b8206cd4490cbd65c0cc.png', //顶部图片
    id: 83,
    extendId: 10,
    coachImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/91e5b7ac09fedd557d557bd64ea4c344.png',
    fixedUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F5a5be18a9c4dc60e9cab6f10cef1cc79.png'
  },
  {
    name: '邓旭美',
    topImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7e5aeb303105d7ef725ecb2d20d91451.png', //顶部图片
    bottomImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/886a7c3ee9c1b8206cd4490cbd65c0cc.png', //顶部图片
    id: 40,
    extendId: 25,
    coachImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/57d029020e87f78d986636d467b63270.png',
    fixedUrl:
      '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F83c0bda4ca8b22d532f743815d0df1f7.png'
  }
]
export { coachDataList }
